import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { ApiResponse, Value } from 'app/types-shared';
import { endpoints } from './endpoints';
import { SubscriberGroupsItemWire } from './types';

export const api = {

  loadLanguageOptions: async (): Promise<Value[]> => {
    const response = await new RemoteAdminData(endpoints.languageOptions)
      .resource<ApiResponse<Value[]>>()
      .all();

    return response.data;
  },

  loadSubscriberGroup: async (id: number): Promise<SubscriberGroupsItemWire> => {
    const response = await new RemoteAdminData(endpoints.subscriberGroupItem)
      .resource<ApiResponse<SubscriberGroupsItemWire>>()
      .withId(id)
      .single();

    return response.data;
  },

  deleteSubscriberGroup: (id: number): Promise<void> => {
    return new RemoteAdminData(endpoints.subscriberGroupItem)
      .resource<void>()
      .withId(id)
      .httpDelete({});
  },

  addSubscriberGroup: async (subscriberGroupItem: SubscriberGroupsItemWire): Promise<number> => {
    const response: any = await new RemoteAdminData(endpoints.subscriberGroupItem)
      .resource<ApiResponse<number>>()
      .create(subscriberGroupItem, false);

    const json: ApiResponse<number> = await response.json();

    return json.data;
  },

  updateSubscriberGroup: async (id: number, subscriberGroupItem: SubscriberGroupsItemWire): Promise<number> => {
    await new RemoteAdminData(endpoints.subscriberGroupItem)
      .resource<void>()
      .withId(id)
      .save(subscriberGroupItem);

    return id;
  }
};
